import { Component } from 'opus-angular-seed-core';

/**
 * Application log screen.
 *
 * Lets a super admin grep the server log files without shell access. The whole
 * filter is a list of include/exclude keywords; results are shown with their
 * original terminal colors and clickable identifiers (process/session/request id).
 */
@Component({
    template: `
        <h1>{{ 'manage.Application log' | translate }}</h1>
        <div class="alert alert-plain">
            <p>{{ 'applicationLog.The log is always filtered by keywords. Add keywords to include or exclude and search.' | translate }}</p>
        </div>
        <manage-logs-applicationlog-filter
            keywords="vm.keywords"
            log-files="vm.logFiles"
            max-keywords="vm.maxKeywords"
            loading="vm.loading"
            on-search="vm.search()"
        ></manage-logs-applicationlog-filter>
        <div class="loader" ng-if="vm.loading">{{ 'general.Loading' | translate }}</div>
        <div class="alert alert-plain" ng-if="!vm.loading && vm.searched && !vm.result.count">
            <p>{{ 'applicationLog.No matching log lines found.' | translate }}</p>
        </div>
        <div class="well" ng-if="!vm.loading && vm.result.count">
            <p class="application-log-summary">
                {{ 'applicationLog.Showing {displayed} of {total} matching lines.' | translate:{ displayed: vm.result.count, total: vm.result.totalMatchCount } }}
            </p>
            <div class="alert alert-plain" ng-if="vm.result.truncated">
                <p>{{ 'applicationLog.Showing the most recent results, some older matches may be hidden.' | translate }}</p>
            </div>
            <manage-logs-applicationlog-output
                rows="vm.result.rows"
                on-token="vm.applyToken(type, value)"
            ></manage-logs-applicationlog-output>
        </div>
    `
})
export default class {
    constructor ($translate, ApplicationLogResource, ApplicationLogService, APPLICATION_LOG) {
        this.$translate = $translate;
        this.ApplicationLogResource = ApplicationLogResource;
        this.ApplicationLogService = ApplicationLogService;
        this.maxKeywords = APPLICATION_LOG.MAX_KEYWORDS;
    }

    $onInit () {
        this.loading = false;
        this.searched = false;
        this.result = null;
        // Start with a single, empty include keyword box.
        this.keywords = [{ value: '', exclude: false }];
        this.logFiles = [];
        this.loadLogFiles();
    }

    /**
     * Loads the list of available log files. By default only today's (active) file is
     * selected so the initial search stays fast on the potentially huge log directory.
     */
    loadLogFiles () {
        this.ApplicationLogResource.logs().$promise
            .then(result => {
                this.logFiles = (result.rows || []).map(row => ({
                    id: row.id,
                    date: row.date,
                    size: row.size,
                    active: row.active,
                    selected: row.active
                }));
            });
    }

    search () {
        this.loading = true;
        const dates = this.logFiles.filter(logFile => logFile.selected).map(logFile => logFile.id);
        this.ApplicationLogResource.search({}, { keywords: this.keywords, dates }).$promise
            .then(result => {
                this.result = result;
                this.searched = true;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    /**
     * Overwrites the whole filter with a single keyword built from the clicked token
     * and immediately re-runs the search.
     */
    applyToken (type, value) {
        this.keywords = [{ value: this.ApplicationLogService.buildTokenKeyword(value), exclude: false }];
        this.search();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/logs/applicationlog/index.js